import { Button, Dialog } from "components/ui";
import { NAVIGATION_ICON } from "constants/app.constant";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

function Dropzone({
  handleFiles,
  fileType,
  isOpen,
  ToggleModal,
  modalWidth,
  closeButtonColor,
  loading,
  isMulti = false,
  icon,
  handleDownload,
  downloadUrl = false,
}) {
  const [uploadedFile, setUploadedFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    setUploadedFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: isMulti,
    accept: fileType,
  });

  const handleSubmit = () => {
    if (uploadedFile.length > 0) {
      handleFiles(uploadedFile);
      ToggleModal();
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={ToggleModal}
      onRequestClose={ToggleModal}
      width={modalWidth}
      contentClassName="p-4"
      closeButtonColor={closeButtonColor}
      closable={false}
    >
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">File Upload</h3>
        {downloadUrl && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleDownload}
            className="flex items-center gap-2 text-blue-600 border-blue-600 hover:bg-blue-50"
          >
            <span>Download Template</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
          </Button>
        )}
      </div>
      <div
        {...getRootProps()}
        className={`border-2 border-dashed p-10 h-[200px] mb-4 rounded-md flex flex-col items-center justify-center ${
          isDragActive ? "border-[#1C2638] bg-[#dce6f7]" : "border-gray-400"
        }`}
      >
        <input {...getInputProps()} />
        <p className="text-gray-500">Drag & Drop files here</p>
        <p className="text-gray-400">or click to select files</p>
      </div>

      {/* Show uploaded files */}
      {uploadedFile.length > 0 && (
        <div className="my-4 overflow-y-auto ">
          {uploadedFile.map((file, index) => (
            <div
              key={index}
              className="flex relative items-center gap-2 mb-2 border"
            >
              <div className="w-[60px] h-[60px] border-r flex items-center justify-center text-[20px]">
                {icon}
              </div>
              <div>
                <p className="font-bold">{file.name}</p>
                <p className="text-gray-500">
                  {(file.size / 1024 / 1024).toFixed(2)} MB
                </p>
              </div>
              <div
                className="absolute right-1 text-[10px] top-1 cursor-pointer flex items-center justify-center hover:bg-gray-100 w-[30px] rounded-md h-[30px]"
                onClick={() =>
                  setUploadedFiles(uploadedFile.filter((item) => item !== file))
                }
              >
                {NAVIGATION_ICON.CROSS_BUTTON}
              </div>
            </div>
          ))}
        </div>
      )}

      <div>
        <Button
          variant="solid"
          size="md"
          className="mr-2"
          loading={loading}
          onClick={handleSubmit}
        >
          Submit
        </Button>
        <Button variant="solid" size="md" onClick={ToggleModal}>
          Cancel
        </Button>
      </div>
    </Dialog>
  );
}

export default Dropzone;
